import Logo from "Utils/Assets/Images/Logo.png";

export const MenuItems = [
  {
    id: 1,
    title: "Tamima Home",
    title_image: true,
    image: Logo,
    action: "/",
    active: true,
    subMenu: [],
  },
  {
    id: 2,
    title: "Roadmap",
    title_image: false,
    image: null,
    action: "/roadmap",
    active: true,
    subMenu: [],
  },
  {
    id: 3,
    title: "Whitepaper",
    title_image: false,
    image: null,
    action: "/whitepaper",
    active: true,
    subMenu: [],
  },
  {
    id: 4,
    title: "Tamima",
    title_image: false,
    image: null,
    action: "/tamima",
    active: true,
    subMenu: [],
  },
  {
    id: 5,
    title: "Creatures",
    title_image: false,
    image: null,
    action: "/creatures",
    active: true,
    subMenu: [],
  },
  {
    id: 6,
    title: "Blogs",
    title_image: false,
    image: null,
    action: "/blogs",
    active: true,
    subMenu: [],
  },
  {
    id: 7,
    title: "Contact us",
    title_image: false,
    image: null,
    action: "/contactus",
    active: true,
    subMenu: [],
  },
];
